import { RankingBarChart } from './RankingBarChart';
import type { NameValueItem } from './types';

type ExtortedApplicationsCountChartProps = {
  data: NameValueItem[];
  loading?: boolean;
  title?: string;
};

export const ExtortedApplicationsCountChart = ({
  data,
  loading = false,
  title = 'SOLICITUDES EXTORNADAS POR CONVENIO',
}: ExtortedApplicationsCountChartProps) => (
  <RankingBarChart title={title} data={data} loading={loading} />
);
